import { useSelector } from 'react-redux';
import { editProfile } from 'redux/modules/auth';
import { openConfirmation } from 'redux/modules/modal';
import { editSettings } from 'redux/modules/settings';
import { RootState } from 'redux/modules/types';
import { useActions } from 'utils/useActions';

export const useConnect = () => {
  const settings = useSelector((state: RootState) => state.settings.settings);

  const actions = useActions({
    openConfirmation,
    editProfile: editProfile.request,
    editSettings: editSettings.request,
  });

  return {
    ...actions,
    settings,
  };
};
